<template>
  <div
    id="audienceEntry"
    class="w-100 h-100"
    :class="[audienceEntryData.code == 404 ? 'f-c-c' : 'f-s-c']"
  >
    <div
      v-if="audienceEntryData.code == 404"
      class="f-c-c"
      style="width: 85%; height: 85%"
    >
      <b-img
        style="width: 100%; height: 100%"
        :src="require(`@/assets/images/audienceEntry/404-icon.svg`)"
      ></b-img>
    </div>
    <div v-else-if="audienceEntryData.code == 310" class="f-c-c w-100 h-100">
      <div v-if="statusPage" class="content404 f-c-c w-100 h-100">
        <div class="right f-c-s f-d-c w-50">
          <div class="up f-c-c f-d-c w-100">
            <b-img
              :src="
                logoUrl
                  ? logoUrl
                  : require(`@/assets/images/audienceEntry/logo-vadagap-one.svg`)
              "
            ></b-img>
            <div class="title f-c-s w-100">
              موضوع جلسه :
              {{ title == "undefined" ? "-" : title }}
            </div>
          </div>
          <div class="center f-c-s w-100">
            {{ note == "undefined" ? "" : note }}
          </div>
          <div class="down f-c-c w-100">
            <div
              class="loginBox f-e-c w-100 h-100"
              style="background-color: white"
            >
              <!-- <b-img
                :src="
                  require(`@/assets/images/audienceEntry/end-meeting-icon.svg`)
                "
              ></b-img> -->
            </div>
          </div>
        </div>
        <div class="left w-50 f-c-c">
          <div class="w-100 h-100 f-c-c" style="background-color: #deeefb">
            <img
              v-if="banerUrl"
              :src="banerUrl"
              style="max-width: 85%; height: 85%; border-radius: 5px"
            />
            <img
              v-else
              :src="require(`@/assets/images/audienceEntry/Group.svg`)"
              style="width: 75%; height: 75%"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="audienceEntryData.code == 311" class="f-c-c w-100 h-100">
      <div v-if="statusPage" class="content404 f-c-c w-100 h-100">
        <div class="right f-c-s f-d-c w-50">
          <div class="up f-c-c f-d-c w-100">
            <b-img
              :src="
                logoUrl
                  ? logoUrl
                  : require(`@/assets/images/audienceEntry/logo-vadagap-one.svg`)
              "
            ></b-img>
            <div class="title f-c-s w-100">
              موضوع جلسه :
              {{ title == "undefined" ? "-" : title }}
            </div>
          </div>
          <div class="center f-c-s w-100">
            {{ note == "undefined" ? "" : note }}
          </div>
          <div class="center f-c-s w-100">
            تاریخ :
            {{ audienceEntryData.date == "" ? "" : audienceEntryData.date }}
          </div>
          <div class="center f-c-s w-100">
            ساعت شروع :
            {{
              audienceEntryData.start_time == ""
                ? ""
                : audienceEntryData.start_time
            }}
          </div>
          <div class="center f-c-s w-100">
            ساعت پایان :
            {{
              audienceEntryData.end_time == "" ? "" : audienceEntryData.end_time
            }}
          </div>
          <div class="down f-c-c w-100">
            <div
              class="loginBox f-e-c w-100 h-100"
              style="background-color: white"
            >
              <b-img
                :src="
                  require(`@/assets/images/audienceEntry/stoped-meeting02.svg`)
                "
              ></b-img>
            </div>
          </div>
        </div>
        <div class="left w-50 f-c-c">
          <div class="w-100 h-100 f-c-c" style="background-color: #deeefb">
            <img
              v-if="banerUrl"
              :src="banerUrl"
              style="max-width: 85%; height: 85%; border-radius: 5px"
            />
            <img
              v-else
              :src="require(`@/assets/images/audienceEntry/Group.svg`)"
              style="width: 75%; height: 75%"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="f-c-c w-100 h-100">
      <div class="content f-c-c w-100 h-100">
        <div v-if="setDirectEntryStatus" class="right f-c-s f-d-c w-50">
          <div class="up f-c-c f-d-c w-100">
            <b-img
              :src="
                logoUrl
                  ? logoUrl
                  : require(`@/assets/images/audienceEntry/logo-vadagap-one.svg`)
              "
            ></b-img>
            <div class="title f-c-c w-100">
              {{ title == "undefined" ? "" : title }}
            </div>
          </div>
          <div class="center f-c-c w-100">
            {{ note == "undefined" ? "" : note }}
          </div>
          <div class="down f-c-c w-100">
            <div class="loginBox f-c-c f-d-c w-100">
              <div class="header f-c-sa w-100 mb-5">
                <div
                  class="item f-c-c"
                  @click="changeTab(1)"
                  :class="[tabStatusId == 1 ? 'active' : '']"
                >
                  ورود به عنوان مهمان
                </div>
                <div
                  class="item f-c-c"
                  @click="changeTab(2)"
                  :class="[tabStatusId == 2 ? 'active' : '']"
                >
                  ورود کاربر
                </div>
              </div>
              <div
                v-if="tabStatusId == 1 && !isPassword && !isCode"
                class="fieldes f-c-s f-d-c w-100 mb-4"
              >
                <div class="row f-c-s w-100 mb-3">
                  <div class="label f-c-s">نام</div>
                  <input
                    class="w-60"
                    type="text"
                    v-model="guestName"
                    @keyup.enter="enterSansFunc()"
                  />
                </div>
                <div class="row f-c-s w-100 mb-3">
                  <div class="label f-c-s">موبایل</div>
                  <input
                    class="w-60"
                    type="mobile"
                    v-model="guestMobile"
                    placeholder="09xxxxxxxxx"
                    @keyup.enter="enterSansFunc()"
                  />
                </div>
                <div class="row f-c-s w-100 mb-4">
                  <div class="label f-c-s">کد امنیتی</div>
                  <div class="w-60 f-c-s position-relative">
                    <input
                      v-model="captcha"
                      type="text"
                      placeholder="کد را وارد کنید"
                      @keyup.enter="enterSansFunc()"
                    />
                    <img
                      :src="
                        'https://vadaroom.ec.iau.ir/captcha.php?ver=' +
                        randCaptcha
                      "
                      alt=""
                      style="
                        width: 55px;
                        margin-bottom: 0.5rem;
                        position: absolute;
                        left: 5px;
                      "
                    />
                  </div>
                </div>
                <div class="btnSection w-100 f-c-s mt-4">
                  <div
                    class="loginBtn f-c-c"
                    @click="isWaiting ? '' : enterSansFunc()"
                  >
                    {{ isWaiting ? "در حال ارسال" : "ورود" }}
                  </div>
                </div>
              </div>
              <div
                v-else-if="tabStatusId == 2 && !isPassword && !isCode"
                class="fieldes f-c-s f-d-c w-100 mb-4"
              >
                <div class="f-c-c w-100">
                  <div class="btnSection directBtn w-100 f-c-c">
                    <div
                      class="loginBtn f-c-c m-0"
                      @click="isWaiting ? '' : directEntryFunc()"
                    >
                      {{ isWaiting ? "در حال ارسال" : "ورود به جلسه" }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else-if="tabStatusId == 2 && isPassword && !isCode"
                class="fieldes f-c-s f-d-c w-100 mb-4"
              >
                <div class="row f-c-s w-100 mb-3">
                  <div class="label f-c-s">رمز عبور</div>
                  <input
                    class="w-60"
                    type="password"
                    v-model="password"
                    @keyup.enter="enterSansFunc()"
                  />
                </div>
                <div class="btnSection w-100 f-c-s mt-4">
                  <div
                    class="loginBtn f-c-c"
                    @click="isWaiting ? '' : enterSansFunc()"
                  >
                    {{ isWaiting ? "در حال ارسال" : "ورود" }}
                  </div>
                </div>
              </div>
              <div
                v-else-if="tabStatusId == 2 && !isPassword && isCode"
                class="fieldes f-c-s f-d-c w-100 mb-4"
              >
                <div class="row f-c-s w-100 mb-3">
                  <div class="label f-c-s">کد تایید</div>
                  <input
                    class="w-60"
                    type="text"
                    v-model="verification"
                    @keyup.enter="enterSansFunc()"
                  />
                </div>
                <div class="btnSection w-100 f-c-s mt-4">
                  <div
                    class="loginBtn f-c-c"
                    @click="isWaiting ? '' : enterSansFunc()"
                  >
                    {{ isWaiting ? "در حال ارسال" : "ورود" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="right f-c-s f-d-c w-50">
          <div class="up f-c-c f-d-c w-100">
            <b-img
              :src="
                logoUrl
                  ? logoUrl
                  : require(`@/assets/images/audienceEntry/logo-vadagap-one.svg`)
              "
            ></b-img>
            <div class="title f-c-c w-100">
              {{ title == "undefined" ? "" : title }}
            </div>
          </div>
          <div class="center f-c-c w-100">
            {{ note == "undefined" ? "" : note }}
          </div>
          <div class="down f-c-c w-100">
            <div class="loginBox f-c-c f-d-c w-100">
              <div class="header f-c-sa w-100 mb-5">
                <div
                  class="item f-c-c"
                  @click="changeTab(1)"
                  :class="[tabStatusId == 1 ? 'active' : '']"
                >
                  ورود به عنوان مهمان
                </div>
                <div
                  class="item f-c-c"
                  @click="changeTab(2)"
                  :class="[tabStatusId == 2 ? 'active' : '']"
                >
                  ورود کاربر
                </div>
              </div>
              <div v-if="tabStatusId == 1" class="w-100 f-c-s">
                <div v-if="!isCode" class="fieldes f-c-s f-d-c w-100 mb-4">
                  <div class="row f-c-s w-100 mb-3">
                    <div class="label f-c-s">نام</div>
                    <input
                      class="w-60"
                      type="text"
                      v-model="guestName"
                      @keyup.enter="enterSansFunc()"
                    />
                  </div>
                  <div class="row f-c-s w-100 mb-3">
                    <div class="label f-c-s">موبایل</div>
                    <input
                      class="w-60"
                      type="mobile"
                      v-model="guestMobile"
                      placeholder="09xxxxxxxxx"
                      @keyup.enter="enterSansFunc()"
                    />
                  </div>
                  <div class="row f-c-s w-100 mb-4">
                    <div class="label f-c-s">کد امنیتی</div>
                    <div class="w-60 f-c-s position-relative">
                      <input
                        v-model="captcha"
                        type="text"
                        placeholder="کد را وارد کنید"
                        @keyup.enter="enterSansFunc()"
                      />
                      <img
                        :src="
                          'https://vadaroom.ec.iau.ir/captcha.php?ver=' +
                          randCaptcha
                        "
                        alt=""
                        style="
                          width: 55px;
                          margin-bottom: 0.5rem;
                          position: absolute;
                          left: 5px;
                        "
                      />
                    </div>
                  </div>
                  <div class="btnSection w-100 f-c-s mt-4">
                    <div
                      class="loginBtn f-c-c"
                      @click="isWaiting ? '' : enterSansFunc()"
                    >
                      {{ isWaiting ? "در حال ارسال" : "ورود" }}
                    </div>
                  </div>
                </div>
                <div v-else class="fieldes f-c-s f-d-c w-100 mb-4">
                  <div class="row f-c-s w-100 mb-3">
                    <div class="label f-c-s">کد تایید</div>
                    <input
                      class="w-60"
                      type="text"
                      v-model="verification"
                      @keyup.enter="enterSansFunc()"
                    />
                  </div>
                  <div class="btnSection w-100 f-c-s mt-4">
                    <div
                      class="loginBtn f-c-c"
                      @click="isWaiting ? '' : enterSansFunc()"
                    >
                      {{ isWaiting ? "در حال ارسال" : "ورود" }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="tabStatusId == 2" class="w-100 f-c-s">
                <div
                  v-if="!isPassword && !isCode"
                  class="fieldes f-c-s f-d-c w-100 mb-4"
                >
                  <div class="row f-c-s w-100 mb-3">
                    <div class="label f-c-s">موبایل</div>
                    <input
                      class="w-60"
                      type="mobile"
                      v-model="mobile"
                      placeholder="09xxxxxxxxx"
                      @keyup.enter="enterSansFunc()"
                    />
                  </div>
                  <div class="row f-c-s w-100 mb-4">
                    <div class="label f-c-s">کد امنیتی</div>
                    <div class="w-60 f-c-s position-relative">
                      <input
                        v-model="captcha"
                        type="text"
                        placeholder="کد را وارد کنید"
                        @keyup.enter="enterSansFunc()"
                      />
                      <img
                        :src="
                          'https://vadaroom.ec.iau.ir/captcha.php?ver=' +
                          randCaptcha
                        "
                        alt=""
                        style="
                          width: 55px;
                          margin-bottom: 0.5rem;
                          position: absolute;
                          left: 5px;
                        "
                      />
                    </div>
                  </div>
                  <div class="btnSection w-100 f-c-s mt-4">
                    <div
                      class="loginBtn f-c-c"
                      @click="isWaiting ? '' : enterSansFunc()"
                    >
                      {{ isWaiting ? "در حال ارسال" : "ورود" }}
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="isPassword && !isCode"
                  class="fieldes f-c-s f-d-c w-100 mb-4"
                >
                  <div class="row f-c-s w-100 mb-3">
                    <div class="label f-c-s">رمز عبور</div>
                    <input
                      class="w-60"
                      type="password"
                      v-model="password"
                      @keyup.enter="enterSansFunc()"
                    />
                  </div>
                  <div class="btnSection w-100 f-c-s mt-4">
                    <div
                      class="loginBtn f-c-c"
                      @click="isWaiting ? '' : enterSansFunc()"
                    >
                      {{ isWaiting ? "در حال ارسال" : "ورود" }}
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="!isPassword && isCode"
                  class="fieldes f-c-s f-d-c w-100 mb-4"
                >
                  <div class="row f-c-s w-100 mb-3">
                    <div class="label f-c-s">کد تایید</div>
                    <input
                      class="w-60"
                      type="text"
                      v-model="verification"
                      @keyup.enter="enterSansFunc()"
                    />
                  </div>
                  <div class="btnSection w-100 f-c-s mt-4">
                    <div
                      class="loginBtn f-c-c"
                      @click="isWaiting ? '' : enterSansFunc()"
                    >
                      {{ isWaiting ? "در حال ارسال" : "ورود" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="left w-50 f-c-c">
          <div class="w-100 h-100 f-c-c" style="background-color: #deeefb">
            <img
              v-if="banerUrl"
              :src="banerUrl"
              style="max-width: 85%; height: 85%; border-radius: 5px"
            />
            <img
              v-else
              :src="require(`@/assets/images/audienceEntry/Group.svg`)"
              style="width: 75%; height: 75%"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="gapMaterial gapMaterialAudienceEntry f-c-c w-100">
      <div class="text f-c-c">
        کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می
        باشد.
      </div>
    </div>
  </div>
</template>
<script>
import CopyRight from "@/components/CopyRight.vue";
import { EventBus } from "@/assistant/EventBus";
import { mapState, mapActions } from "vuex";
export default {
  name: "AudienceEntry",
  data() {
    return {
      tabStatusId: 1,
      isWaiting: false,
      guestName: "",
      captcha: "",
      guestMobile: "",
      guestEmail: "",
      guestGender: "",
      mobile: "",
      userId: null,
      banerUrl: null,
      logoUrl: null,
      note: "",
      date: "",
      sTime: "",
      eTime: "",
      title: "",
      p: null,
      l: null,
      statusPage: false,
      isPassword: false,
      isCode: false,
      isGuestCode: false,
      verification: "",
      password: "",
      isShowCopy: false,
      randCaptcha: 123456,
    };
  },
  created() {
    this.statusPage = false;
    EventBus.$on("copyright", (status) => {
      if (status && this.isShowCopy) {
        this.isShowCopy = false;
      }
    });
    this.p = this.$route.path.split("/");
    this.l = this.p.length;
    this.getAudienceEntryDataFunction({
      url: this.p[this.l - 1],
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      userEnter: (state) => state.gap.userEnter,
      guestEnterStatus: (state) => state.gap.guestEnterStatus,
      audienceEntryData: (state) => state.gap.audienceEntryData,
      userEnterStatus: (state) => state.gap.userEnterStatus,
      userprofile: (state) => state.gap.userprofile,
      userStatus: (state) => state.gap.userStatus,
      tabStatus: (state) => state.gap.tabStatus,
      guestCodeStatus: (state) => state.gap.guestCodeStatus,
      directEntryStatus: (state) => state.gap.directEntryStatus,
      setDirectEntryStatus: (state) => state.gap.setDirectEntryStatus,
    }),
  },
  components: { CopyRight },
  methods: {
    ...mapActions("gap", [
      "confirmCodeFunction",
      "guestEnterFunction",
      "userEnterFunction",
      "setTabStatusFunction",
      "getAudienceEntryDataFunction",
      "loginWithPassFunction",
      "confirmGuestCodeFunction",
      "directEntryFunction",
      "setDirectEntryFunction",
    ]),
    mobileNumber(Number) {
      var IndNum = /^[0]?[789]\d{9}$/;

      if (IndNum.test(Number) && Number.length == 11) {
        return true;
      } else {
        return false;
      }
    },
    validateEmail(email) {
      return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    copyRightFunc() {
      this.isShowCopy = !this.isShowCopy;
    },
    changeTab(i) {
      this.tabStatusId = i;
      this.isPassword = false;
      this.isCode = false;
      this.isGuestCode = false;
    },
    enterSansFunc() {
      if (this.tabStatusId == 1 && !this.isCode) {
        if (this.audienceEntryData.guest_login) {
          if (this.guestName == "") {
            this.$bvToast.toast("نام را وارد نمایید.", {
              title: "خطا",
              variant: "danger",
              solid: true,
            });
          } else if (this.guestMobile == "") {
            this.$bvToast.toast("پر کردن موبایل الزامی است.", {
              title: "خطا",
              variant: "danger",
              solid: true,
            });
          } else if (!this.mobileNumber(this.guestMobile)) {
            this.$bvToast.toast("شماره موبایل را بصورت صحیح وارد نمایید.", {
              title: "خطا",
              variant: "danger",
              solid: true,
            });
          } else {
            this.isWaiting = true;
            this.guestEnterFunction({
              user_id: this.user.user_id,
              name: this.guestName,
              mobile: this.guestMobile,
              captcha: this.captcha,
              url: this.p[this.l - 1],
            });
          }
        } else {
          this.$bvToast.toast("ورود به عنوان مهمان امکان پذیر نمی باشد.", {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      } else {
        if (this.isPassword) {
          if (this.password == "") {
            this.$bvToast.toast("رمز عبور را وارد نمایید.", {
              title: "خطا",
              variant: "danger",
              solid: true,
            });
          } else {
            this.isWaiting = true;
            this.loginWithPassFunction({
              user_id: this.userId,
              password: this.password,
              session_url: this.p[this.l - 1],
            });
          }
        } else if (this.isCode) {
          if (this.verification == "") {
            this.$bvToast.toast("کد تایید را وارد نمایید.", {
              title: "خطا",
              variant: "danger",
              solid: true,
            });
          } else {
            if (this.isGuestCode) {
              this.isWaiting = true;
              this.confirmGuestCodeFunction({
                code: this.verification,
              });
            } else {
              this.isWaiting = true;
              this.confirmCodeFunction({
                user_id: this.userId,
                code: this.verification,
                session_url: this.p[this.l - 1],
              });
            }
          }
        } else {
          if (this.mobile == "") {
            this.$bvToast.toast("موبایل را وارد نمایید.", {
              title: "خطا",
              variant: "danger",
              solid: true,
            });
          } else {
            this.isWaiting = true;
            this.userEnterFunction({
              user_id: this.user.user_id,
              mobile: this.mobile,
              captcha: this.captcha,
              url: this.p[this.l - 1],
            });
          }
        }
      }
    },
    directEntryFunc() {
      this.isWaiting = true;
      this.directEntryFunction({
        user_id: this.user.user_id,
        session_url: this.p[this.l - 1],
      });
    },
    randomInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
  },
  watch: {
    directEntryStatus(n) {
      if (Object.keys(n).length) {
        this.isWaiting = false;
        if (n.code == 100) {
          if (n.join_url) {
            window.location.href = n.join_url;
          }
        } else {
          this.randCaptcha = this.randomInteger(10000, 999999);
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    userEnterStatus(n) {
      if (Object.keys(n).length) {
        this.isWaiting = false;
        if (n.confirm_type == "password") {
          this.isPassword = true;
          this.userId = n.user_id;
        } else if (n.confirm_type == "code") {
          this.isCode = true;
          this.userId = n.user_id;
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
        } else {
          this.randCaptcha = this.randomInteger(10000, 999999);
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    guestCodeStatus(n) {
      if (Object.keys(n).length) {
        this.isWaiting = false;
        if (n.code == 100) {
          if (n.join_url) {
            this.setDirectEntryFunction(false);
            window.location.href = n.join_url;
          }
        } else {
          this.randCaptcha = this.randomInteger(10000, 999999);
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    audienceEntryData(n) {
      if (Object.keys(n).length) {
        this.isWaiting = false;
        if (n.code == 100) {
          this.statusPage = false;
          this.banerUrl = n.banner;
          this.logoUrl = n.logo;
          this.note = n.note;
          this.title = n.title;
        } else {
          this.banerUrl = n.banner;
          this.logoUrl = n.logo;
          this.note = n.note;
          this.title = n.title;
          this.statusPage = true;
          this.setTabStatusFunction(2);
        }
        if (n.code == 404) {
          this.statusPage = false;
          this.setTabStatusFunction(1);
        }
      }
    },
    userEnter() {},
    guestEnterStatus(n) {
      if (Object.keys(n).length) {
        this.isWaiting = false;
        if (n.code == 100) {
          window.location.href = n.join_url;
        } else {
          if (n.confirm_type == "code") {
            this.isCode = true;
            this.isGuestCode = true;
            this.$bvToast.toast(n.message, {
              title: "تایید",
              variant: "success",
              solid: true,
            });
          } else {
            this.randCaptcha = this.randomInteger(10000, 999999);
            this.$bvToast.toast(n.message, {
              title: "خطا",
              variant: "danger",
              solid: true,
            });
          }
        }
      }
    },
    userprofile(n) {
      if (Object.keys(n).length) {
        this.isWaiting = false;
        if (n.code == 100) {
          if (n.join_url) {
            this.setDirectEntryFunction(false);
            window.location.href = n.join_url;
          }
        } else {
          this.randCaptcha = this.randomInteger(10000, 999999);
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    userStatus(n) {
      if (Object.keys(n).length) {
        this.isWaiting = false;
        if (n.code == 100) {
          if (n.join_url) {
            this.setDirectEntryFunction(false);
            window.location.href = n.join_url;
          }
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
  },
  mounted() {
    if (this.setDirectEntryStatus) {
      this.tabStatusId = 2;
    }
    this.randCaptcha = this.randomInteger(10000, 999999);
  },
  beforeDestroy() {
    this.setDirectEntryFunction(false);
  },
};
</script>
<style lang="scss" scoped>
#audienceEntry {
  background-color: #8ebbdf;
  padding: 4%;
  .content404 {
    max-width: 1600px;
    .right {
      height: 50vw;
      max-height: 100%;
      background-color: white;
      border-radius: 0 30px 30px 0;
      padding: 1% 5%;
      overflow: auto;
      .up {
        padding-top: 5%;
        img {
          width: 15%;
          margin-bottom: 5%;
        }
        .title {
          color: #125488;
          font-weight: bold;
        }
      }
      .center {
        color: #125488;
        font-size: 80%;
        margin-bottom: 5%;
      }
      .down {
        height: 60%;
        .loginBox {
          background-color: #edf7ff;
          border-radius: 10px;
          padding: 5%;
          .fieldes {
            img {
              width: 20%;
              margin-bottom: 5%;
            }
            .text {
              font-size: 85%;
              color: #125488;
            }
          }
        }
      }
    }
    .left {
      height: 50vw;
      max-height: 100%;
      position: relative;
      overflow: hidden;
      .blurBack {
        filter: blur(5px);
        -webkit-filter: blur(5px);
        width: 100%;
        height: 100%;
        background-repeat: no-repeat !important;
        background-size: cover !important;
        background-position: center !important;
        border-radius: 30px 0 0 30px;
      }
      .imgBox {
        width: 90%;
        height: 90%;
        position: absolute;
        background-size: contain !important;
        background-repeat: no-repeat !important;
        background-position: center !important;
      }
      border-radius: 30px 0 0 30px;
    }
  }
  .content {
    max-width: 1600px;
    .right {
      height: 50vw;
      max-height: 100%;
      background-color: white;
      border-radius: 0 30px 30px 0;
      padding: 1% 5%;
      overflow: auto;
      .up {
        padding-top: 5%;
        img {
          width: 15%;
          margin-bottom: 5%;
        }
        .title {
          color: #125488;
          font-weight: bold;
        }
      }
      .center {
        color: #125488;
        font-size: 80%;
        margin-bottom: 5%;
      }
      .down {
        .loginBox {
          background-color: #edf7ff;
          border-radius: 10px;
          padding: 5%;
          .header {
            .item {
              color: #125488;
              cursor: pointer;
              padding-bottom: 3px;
              border-bottom: 1px solid #125488;
              font-size: 90%;
            }
            .active {
              color: #125488;
              border-bottom-color: #125488;
              font-weight: bold;
            }
          }
          .fieldes {
            .row {
              .label {
                width: 30%;
                padding-right: 8%;
                font-size: 85%;
                color: #125488;
              }
              input {
                &:focus {
                  outline: none;
                }
                &:focus-visible {
                  outline: none;
                }
                background: #ffffff;
                border-radius: 4px;
                border: none;
                color: #125488;
                padding: 0.35rem;
                padding-right: 0.5rem;
                letter-spacing: 1px;
                font-size: 80%;
                width: 100%;
                &::placeholder {
                  color: #c9c9c9;
                  opacity: 1;
                }

                &:-ms-input-placeholder {
                  color: #c9c9c9;
                }

                &::-ms-input-placeholder {
                  color: #c9c9c9;
                }
              }
              select {
                width: 60%;
                max-width: unset;
                min-width: unset;
                border: none;
                border-radius: 4px;
                color: #125488;
                font-size: 0.8rem;
                padding: 6px 10px 5px 20px;
                &:focus {
                  outline: none;
                }
                &:focus-visible {
                  outline: none;
                }
                -webkit-appearance: none;
                -moz-appearance: none;
                background: #ffffff
                  url("~@/assets/images/login/selectArrow.svg") no-repeat;
                background-position: 5% 50%;
                -webkit-border-radius: 4px;
                -moz-border-radius: 4px;
                -ms-border-radius: 4px;
                -o-border-radius: 4px;
              }
            }
          }
          .btnSection {
            .loginBtn {
              cursor: pointer;
              color: #ffffff;
              background-color: #125488;
              padding: 0.3rem 0;
              margin-right: 30%;
              width: 60%;
              border-radius: 16px;
              font-size: 80%;
            }
          }
          .directBtn {
            padding: 0.5rem 0;
          }
        }
      }
    }
    .left {
      height: 50vw;
      max-height: 100%;
      position: relative;
      overflow: hidden;
      .blurBack {
        filter: blur(5px);
        -webkit-filter: blur(5px);
        width: 100%;
        height: 100%;
        background-repeat: no-repeat !important;
        background-size: cover !important;
        background-position: center !important;
        border-radius: 30px 0 0 30px;
      }
      .imgBox {
        width: 90%;
        height: 90%;
        position: absolute;
        background-size: contain !important;
        background-repeat: no-repeat !important;
        background-position: center !important;
      }
      border-radius: 30px 0 0 30px;
    }
  }
}
</style>